// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-icons__list{display:flex;flex-wrap:wrap;justify-content:center;margin:0 -5px -15px}@media only screen and (min-width:992px){.payment-icons__list{margin:0 -10px -20px;justify-content:flex-start}}.payment-icons__item{margin:0 5px 15px}.payment-icons__item img{height:22px}@media only screen and (min-width:992px){.payment-icons__item img{height:18px}}@media only screen and (min-width:1365px){.payment-icons__item{margin:0 10px 20px}.payment-icons__item img{height:22px}}", ""]);
// Exports
module.exports = exports;
